import React, { CSSProperties, Component } from 'react';
import styles from './index.css';
import classNames from 'classnames';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const DISABLE_OPACITY = 0.24;
export const MARGIN_RIGHT = 8;

interface HocToolbarItemProps {
    id?: string;
    tipMsg?: string;
    selected?: boolean;
    disabled?: boolean;
    handleMouseDown: (id, value) => void;
    handleTouchStart: (id, value) => void;
    handleDoubleClick?: () => void;
    value?: boolean;
    dropdown?: any;
    style?: CSSProperties;
    content?: string;
}

interface HocToolbarItemState {
    value?: boolean;
    startPoint: { x: number; y: number; }|null,
}

export const hocToolbarItem = TitleComponent => class ToolBarItem extends
    Component<HocToolbarItemProps, HocToolbarItemState> {
    private needBackgroundSelectedStyle: boolean;
    private iconRef: HTMLDivElement|null;
    public constructor(props: HocToolbarItemProps) {
        super(props);
        this.needBackgroundSelectedStyle = true;

        this.state = {
            value: this.props.value,
            startPoint: null,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps: HocToolbarItemProps) {
        const { value } = nextProps;
        this.setState({
            value,
        });
    }

    public componentDidMount() {
        if (this.iconRef) {
            // 通过addEventListener添加事件，并提供preventDefault,可以阻止mouse事件。避免移动端重复触发
            this.iconRef.addEventListener('touchend', this.handleTouchEnd, { passive: false });
        }
    }

    public componentWillUnmount() {
        if (this.iconRef) {
            this.iconRef.removeEventListener('touchend', this.handleTouchEnd);
        }
    }

    public render() {
        const addSlide = this.props.id === ActionType.ADD_SLIDE;
        // 编辑面板需求开启前，选中使用下划线样式，需求面板需求开启后，使用背景置灰样式
        const selectedStyle = this.needBackgroundSelectedStyle ? styles['background-selected'] : styles.selected;
        const itemClass = classNames({
            [styles.item]: !addSlide,
            [selectedStyle]: this.props.selected || this.state.value === true,
        });

        const itemStyle: CSSProperties = { display: 'inline-flex' };
        if (this.props.disabled) {
            itemStyle.opacity = DISABLE_OPACITY;
        }
        if (this.props.id === 'evoke-keyboard') {
            itemStyle.marginRight = MARGIN_RIGHT;
        }

        return (
            <div
                id={this.props.id}
                className={itemClass}
                style={{
                    ...itemStyle,
                    ...this.props.style,
                }}
                ref={(el) => {
                    this.iconRef = el;
                }}
                onTouchStart={this.handleTouchStart}
                onTouchEnd={this.touchEnd}
                onMouseDown={this.handleMouseDown}
            >
                <div className={styles['inner-item']}>
                    <TitleComponent {...this.props} />
                    {
                        this.props.dropdown?.icon
                            ? <img className={styles.dropIcon} src={this.props.dropdown.icon} />
                            :                            null
                    }
                </div>
                <div className={styles.selectedTips}></div>
            </div>
        );
    }

    private handleMouseDown = (e) => {
        const pressClass = classNames({
            [styles.press]: true,
        });
        this.iconRef?.classList.add(pressClass);
        // 如果是被禁止的按钮，不做任何操作
        if (this.props.disabled) {
            return;
        }

        if (this.state.value !== null) {
            let value = this.state.value !== null && this.state.value !== undefined
                ? this.state.value
                : this.props.value;
            if (typeof value === 'boolean') {
                value = !value;
                this.setState({ value });
            }
            this.props.handleMouseDown(this.props.id, value);
        } else {
            this.props.handleMouseDown(this.props.id, null);
        }
        this.iconRef?.classList.remove(pressClass);
        e.preventDefault();
    };

    private handleTouchStart = (e) => {
        const pressClass = classNames({
            [styles.press]: true,
        });
        this.iconRef?.classList.add(pressClass);
        const startPoint = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY,
        };

        this.setState({
            startPoint,
        });
        e.stopPropagation();
        e.preventDefault();
    };

    private touchEnd = () => {
        const pressClass = classNames({
            [styles.press]: true,
        });
        this.iconRef?.classList.remove(pressClass);
    };

    private handleTouchEnd = (e) => {
        this.touchEnd();
        e.preventDefault();
        e.stopPropagation();
        const nowPoint = {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY,
        };

        if (this.state.startPoint) {
            const { x, y } = this.state.startPoint;
            // 点击加 5px 的冗余，否则移动端容易点击不生效
            if (Math.abs(nowPoint.x - x) > 5 || Math.abs(nowPoint.y - y) > 5) {
                return;
            }
        }

        // 如果是被禁止的按钮，不做任何操作
        if (this.props.disabled) {
            return;
        }

        if (this.state.value !== null) {
            // let value = this.state.value;
            let value = ((this.state.value !== null) && (this.state.value !== undefined))
                ? this.state.value
                : this.props.value;
            if (typeof value === 'boolean') {
                value = !value;
                this.setState({ value });
            }
            this.props.handleTouchStart(this.props.id, value);
        } else {
            this.props.handleTouchStart(this.props.id, null);
        }
    };
};
